var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ml-4 mr-4" },
    [
      _vm.type === "create"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col company-h1" }, [
                  _c("button", {
                    staticClass: "btn btn-back",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-map")
                      }
                    }
                  }),
                  _vm._v("\n        Create Company\n      ")
                ]),
                _vm._v(" "),
                _vm.$_can("companies.update")
                  ? _c("div", { staticClass: "col text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: { click: _vm.save }
                        },
                        [
                          _vm._v("\n          Save\n          "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("companies-steps-menu", {
                attrs: { type: "create", "saved-settings": _vm.savedSettings }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("companies.update")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary ld-ext-right ml-5",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: { type: "button" },
                            on: { click: _vm.save }
                          },
                          [
                            _vm._v("\n          Save\n          "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.$_can("leads.follow-up-email-templates.index")
          ? _c("div", { staticClass: "col-8 email-templates" }, [
              _c("div", { staticClass: "l-header-2" }, [
                _vm._v("Email templates")
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  on: {
                    click: function($event) {
                      _vm.$_can("automated-emails.update") &&
                        _vm.toggleSendAutomaticEmails()
                    }
                  }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "switch",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.company.send_automatic_emails }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "check-slider round" })
                    ]
                  ),
                  _vm._v("Send automated emails\n      ")
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.company.send_automatic_emails,
                      expression: "company.send_automatic_emails"
                    }
                  ]
                },
                [
                  _c("h6", [
                    _vm._v(
                      "\n          We are sending default emails when certain actions are taken. You can toggle it from default and add your\n          own text so they would contain information that matches your company needs.\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "email-templates-wrap rounded-top" },
                    _vm._l(_vm.templateTypes, function(templateType) {
                      return _c(
                        "p",
                        {
                          key: templateType.id,
                          on: {
                            click: function($event) {
                              _vm.$_can(
                                "leads.follow-up-email-templates.store"
                              ) && _vm.openModalEmailTemplate(templateType.id)
                            }
                          }
                        },
                        [
                          _c("label", { staticClass: "switch" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                disabled: !_vm.$_can(
                                  "leads.follow-up-email-templates.store"
                                )
                              },
                              domProps: {
                                checked: _vm.editedTemplates.find(function(e) {
                                  return e.email_type_id === templateType.id
                                })
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "check-slider round" })
                          ]),
                          _vm._v("\n            " + _vm._s(templateType.name)),
                          _c("span", { staticClass: "mod-icon mod-icon-edit" })
                        ]
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3 mb-3" }, [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Send copy of automated emails to")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.email_copy,
                            expression: "company.email_copy"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { disabled: !_vm.$_can("companies.update") },
                        domProps: { value: _vm.company.email_copy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "email_copy",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showModalEmailTemplate
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Email template")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col pr-1" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Company")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mx-3" }, [
                          _vm._v(_vm._s(_vm.company.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "company_id" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col pl-1" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Types")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mx-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.templateTypes.find(function(e) {
                                return e.id === _vm.template.email_type_id
                              }).name
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "email_type_id" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Email subject")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.subject,
                              expression: "template.subject"
                            }
                          ],
                          ref: "subject",
                          staticClass: "form-control",
                          domProps: { value: _vm.template.subject },
                          on: {
                            click: function($event) {
                              _vm.addingVariableOn = "subject"
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "subject",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "subject" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap h-auto" }, [
                        _c("label", [_vm._v("Email text")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.content,
                              expression: "template.content"
                            }
                          ],
                          ref: "ta",
                          staticClass: "form-control email-templates-textarea",
                          attrs: { contenteditable: "true" },
                          domProps: { value: _vm.template.content },
                          on: {
                            click: function($event) {
                              _vm.addingVariableOn = "ta"
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "content",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "content" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("label", [_vm._v("Variables")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.template.variables, function(
                        variable,
                        key,
                        index
                      ) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass:
                              "badge badge-primary mx-1 unselectable pointer",
                            on: {
                              dblclick: function($event) {
                                _vm.insertVariable(variable)
                              }
                            }
                          },
                          [_vm._v(_vm._s(key))]
                        )
                      })
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.template.available_settings &&
                Object.keys(_vm.template.available_settings).length
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("label", [_vm._v("Settings")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.template.available_settings, function(
                            setting,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "col-12 col-sm-12 col-md-3 mr-2"
                              },
                              [
                                _vm.template.settings
                                  ? _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(setting.label))
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.template.settings[index],
                                            expression:
                                              "template.settings[index]"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        domProps: {
                                          value: _vm.template.settings[index]
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.template.settings,
                                              index,
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  : _vm._e()
                              ]
                            )
                          })
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _vm.$_can("leads.follow-up-email-templates.destroy")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.deleteTemplate }
                          },
                          [_vm._v("\n            Delete template\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("leads.follow-up-email-templates.update")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary ld-ext-right",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: {
                              type: "button",
                              disabled: _vm.buttonDisabled
                            },
                            on: { click: _vm.saveEmailTemplate }
                          },
                          [
                            _vm._v("\n            Save template\n            "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55b86244", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b86244","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesEmails.vue
// module id = null
// module chunks = 